module.exports = {
	"textures": [
		{
			"image": "WinAtlas",
			"format": "RGBA8888",
			"size": {
				"w": 908,
				"h": 562
			},
			"scale": 1,
			"frames": [
				{
					"filename": "Glow.png",
					"rotated": false,
					"trimmed": false,
					"sourceSize": {
						"w": 444,
						"h": 444
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 444,
						"h": 444
					},
					"frame": {
						"x": 2,
						"y": 2,
						"w": 444,
						"h": 444
					}
				},
				{
					"filename": "Jackpot.png",
					"rotated": false,
					"trimmed": false,
					"sourceSize": {
						"w": 705,
						"h": 110
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 705,
						"h": 110
					},
					"frame": {
						"x": 2,
						"y": 450,
						"w": 705,
						"h": 110
					}
				},
				{
					"filename": "Mega.png",
					"rotated": false,
					"trimmed": false,
					"sourceSize": {
						"w": 456,
						"h": 103
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 456,
						"h": 103
					},
					"frame": {
						"x": 450,
						"y": 2,
						"w": 456,
						"h": 103
					}
				},
				{
					"filename": "Epic.png",
					"rotated": false,
					"trimmed": false,
					"sourceSize": {
						"w": 377,
						"h": 101
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 377,
						"h": 101
					},
					"frame": {
						"x": 450,
						"y": 109,
						"w": 377,
						"h": 101
					}
				},
				{
					"filename": "Win.png",
					"rotated": false,
					"trimmed": false,
					"sourceSize": {
						"w": 320,
						"h": 100
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 320,
						"h": 100
					},
					"frame": {
						"x": 450,
						"y": 214,
						"w": 320,
						"h": 100
					}
				},
				{
					"filename": "Big.png",
					"rotated": false,
					"trimmed": false,
					"sourceSize": {
						"w": 278,
						"h": 102
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 278,
						"h": 102
					},
					"frame": {
						"x": 450,
						"y": 318,
						"w": 278,
						"h": 102
					}
				},
				{
					"filename": "betIcon.png",
					"rotated": false,
					"trimmed": false,
					"sourceSize": {
						"w": 64,
						"h": 64
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 64,
						"h": 64
					},
					"frame": {
						"x": 711,
						"y": 424,
						"w": 64,
						"h": 64
					}
				},
				{
					"filename": "creditsIcon.png",
					"rotated": false,
					"trimmed": false,
					"sourceSize": {
						"w": 64,
						"h": 64
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 64,
						"h": 64
					},
					"frame": {
						"x": 774,
						"y": 214,
						"w": 64,
						"h": 64
					}
				},
				{
					"filename": "winIcon.png",
					"rotated": false,
					"trimmed": false,
					"sourceSize": {
						"w": 64,
						"h": 64
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 64,
						"h": 64
					},
					"frame": {
						"x": 831,
						"y": 109,
						"w": 64,
						"h": 64
					}
				}
			]
		}
	],
	"meta": {
		"app": "http://free-tex-packer.com",
		"version": "0.6.7"
	}
};